module.exports = __webpack_public_path__ + "static/2Front-logo-white-6951af50fe8e0e086e08116002c34a41.png";